{
  "toasts": {
    "created": "Template created successfully!",
    "createError": "Failed to create template",
    "restored": "Template restored to default",
    "restoreError": "Failed to restore template",
    "updated": "Template updated successfully!",
    "updateError": "Failed to update template",
    "saveError": "Failed to save template"
  },
  "page": {
    "title": "Email Templates",
    "subtitle": "Configure the emails sent automatically for each platform event"
  },
  "categories": {
    "authentication": "Authentication",
    "enrollments": "Enrollments",
    "progress": "Progress",
    "payments": "Payments",
    "community": "Community",
    "gamification": "Gamification",
    "allWithCount": "All ({{count}})",
    "withCount": "{{label}} ({{count}})"
  },
  "stats": {
    "mappedEvents": "Mapped events",
    "createdTemplates": "Templates created",
    "active": "Active",
    "inactive": "Inactive"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "noTemplate": "No template",
    "toggleAllLanguages": "Turns the template on or off in every language"
  },
  "actions": {
    "edit": "Edit",
    "createTemplate": "Create template",
    "cancel": "Cancel",
    "save": "Save"
  },
  "reset": {
    "title": "Reset template",
    "description": "The subject and content in {{language}} go back to the platform default. Any changes made in this language will be lost.",
    "confirm": "Reset"
  },
  "logo": {
    "alt": "Logo",
    "title": "Email logo",
    "descriptionWithLogo": "Shown automatically at the top of every template.",
    "descriptionEmpty": "Upload a logo to show in every email (PNG, JPG or SVG, up to 2MB).",
    "remove": "Remove",
    "replace": "Replace",
    "upload": "Upload logo"
  },
  "editor": {
    "fallbackTitle": "Template",
    "createTitle": "Create: {{title}}",
    "editTitle": "Edit: {{title}}",
    "subject": "Email subject",
    "subjectPlaceholder": "Email subject with {{open}}variables{{close}}",
    "variables": "Available variables",
    "variablesHint": "(click to insert into the editor)",
    "preview": "Preview",
    "from": "From:",
    "to": "To:",
    "subjectLabel": "Subject:",
    "previewFrameTitle": "Email preview",
    "newLanguage": "New",
    "unsavedChanges": "Unsaved changes",
    "missingLanguage": "This language doesn't have a template yet. The content below is the platform default and will be created when you save."
  },
  "languages": {
    "label": "Template languages",
    "available": "{{language}}: created",
    "missing": "{{language}}: not created yet"
  },
  "eventCatalog": {
    "first-access": {
      "name": "User created",
      "description": "Sent when a new user is created. Welcomes them or sends first-access credentials."
    },
    "user-updated": {
      "name": "User updated",
      "description": "Sent when the user profile data changes (e.g. email, name)."
    },
    "password-reset": {
      "name": "Password reset",
      "description": "Sent when the user or an admin requests a password reset. Includes a link to set a new password."
    },
    "login-new-device": {
      "name": "Sign-in from a new device",
      "description": "Security alert sent when the user signs in from a new device or browser."
    },
    "enrollment-confirmation": {
      "name": "Enrollment created",
      "description": "Sent when the user is enrolled in a course (purchase, admin or access group)."
    },
    "enrollment-removed": {
      "name": "Enrollment removed",
      "description": "Sent when a user enrollment is cancelled or expires."
    },
    "enrollment-expiring": {
      "name": "Enrollment expiring",
      "description": "Sent a few days before the student enrollment expires. Great for renewals."
    },
    "enrollment-expired": {
      "name": "Enrollment expired",
      "description": "Sent when the student enrollment has expired and access was removed."
    },
    "lesson-added": {
      "name": "Lesson added",
      "description": "Sent when a new lesson is published. Notifies every student enrolled in the course."
    },
    "lesson-completed": {
      "name": "Lesson completed",
      "description": "Sent when the student completes a lesson. Great for celebrating progress."
    },
    "module-completed": {
      "name": "Module completed",
      "description": "Sent when the student completes every lesson in a course module."
    },
    "course-completed": {
      "name": "Course completed",
      "description": "Sent when the student completes 100% of a course. Time to celebrate!"
    },
    "certificate-issued": {
      "name": "Certificate issued",
      "description": "Sent when a completion certificate is generated for the student."
    },
    "inactivity-reminder": {
      "name": "Inactivity reminder",
      "description": "Re-engagement: sent when the student has not visited the platform for X days."
    },
    "payment-confirmed": {
      "name": "Payment approved",
      "description": "Sent when a payment is confirmed. Includes the confirmation and access to the content."
    },
    "payment-refunded": {
      "name": "Payment refunded",
      "description": "Sent when a refund is processed. Lets the user know about it."
    },
    "comment-reply": {
      "name": "Comment reply",
      "description": "Sent when someone replies to the user comment on a lesson."
    },
    "comment-reaction": {
      "name": "Comment reaction",
      "description": "Sent when someone reacts to the user comment (like, etc.)."
    },
    "comment-mention": {
      "name": "Comment mention",
      "description": "Sent when someone mentions the user (@name) in a comment or reply."
    },
    "points-earned": {
      "name": "Points earned",
      "description": "Sent when the user earns XP for completing actions. High frequency, off by default."
    },
    "level-up": {
      "name": "Level up",
      "description": "Sent when the user levels up in the gamification system. Time to celebrate!"
    },
    "badge-earned": {
      "name": "Achievement unlocked",
      "description": "Sent when the user earns a new badge or trophy on the platform."
    },
    "weekly-report": {
      "name": "Weekly report",
      "description": "Weekly summary of the student progress: lessons watched, XP earned and leaderboard position."
    }
  }
}
